import React, { useState } from "react";
import "../Styles/OtherServices.css";
import { useNavigate } from "react-router-dom";

const flyerList = [
  "/flyers/flyer1.png",
  "/flyers/flyer2.png",
  "/flyers/flyer3.png",
  "/flyers/flyer4.png",
  "/flyers/flyer5.png"
];

const OtherServices = () => {
  const [selectedFlyer, setSelectedFlyer] = useState(null);
    const navigate = useNavigate();

  return (
    <div className="others-page">
      <button className="back-button" onClick={() => navigate("/services")}>
  ← Back to Services
</button>
      {/* ✅ Main Header Container */}
      <div className="header-container">
        <h2>🛠️ Other Services</h2>
      </div>

      {/* ✅ Description / Content */}
      <div className="description">
        <p>
          RCS has a vast collection of services tailored to meet the needs of our customers. Apart from the aforementioned services,
          RCS also offers the following:
        </p>
        <ul className="mmg-bullet-list">
          <li>Superbet Online Top-Up and Cashouts</li>
          <li>Online Shopping</li>
          <li>Gamers Recharge (PUBG, CODM, FREE FIRE, etc)</li>
          <li>Financial Services – Wire Transfers, Cheque Exchange, Damaged Currency Exchange</li>
          <li>Tax Services</li>
          <li>Printing and Photocopying</li>
          <li>Stationery Supplies</li>
          <li>Immigration Services – Passport Forms</li>
          <li>VISA Renewal Applications – USA & Canada</li>
          <li>Airline & International Hotel Bookings</li>
        </ul>
      </div>

      {/* ✅ Flyer Section */}
      <div className="flyer-section">
        <h4>📢 Explore Our Service Flyers</h4>
        <div className="flyer-grid">
          {flyerList.map((flyer, index) => (
            <div className="flyer-card" key={index} onClick={() => setSelectedFlyer(flyer)}>
              <img src={flyer} alt={`Flyer ${index + 1}`} className="flyer-img" />
            </div>
          ))}
        </div>
      </div>

      {/* ✅ Fullscreen Flyer Modal */}
      {selectedFlyer && (
        <div className="flyer-modal" onClick={() => setSelectedFlyer(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedFlyer} alt="Full Flyer" />
            <button className="close-btn" onClick={() => setSelectedFlyer(null)}>✖</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtherServices;
